import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Button from '../Button';
import Icon from '../Icon';
import Tooltip from 'bootstrap/js/dist/tooltip';

export interface IVHSAlertBarProps extends IBaseElementProps {
	alertText?: string;
	tooltipText?: string;
}

/**
 * AlertBar
 * @block
 * @icon columns
 */
const VHSAlertBar: React.FC<IVHSAlertBarProps> = ({
	alertText,
	className,
	tooltipText,
}) => {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!ref.current) {
			return;
		}

		const initTooltip = () => {
			const tooltipTriggerList = [].slice.call(
				ref.current.querySelectorAll('.vhs-alert__tooltip'),
			);

			tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new Tooltip(tooltipTriggerEl);
			});
		};

		initTooltip();
	}, []);

	return (
		<div className="justify-content-center" ref={ref}>
			<p>
				<span dangerouslySetInnerHTML={{ __html: alertText }}></span>
				{tooltipText != '' && (
					<button
						type="button"
						className="vhs-alert__tooltip"
						data-bs-toggle="tooltip"
						data-bs-placement="top"
						data-bs-trigger="click"
						data-bs-title={tooltipText}
						aria-label="Tooltip"
					>
						<Icon name="info" />
					</button>
				)}
			</p>
		</div>
	);
};

export default VHSAlertBar;
